import React, { Component } from 'react';
import PropTypes from 'prop-types'
import { MuiThemeProvider } from '@material-ui/core/styles';
import { PAGES } from './util/constants'
import { drawerIsOpen, getPageTitle } from './util/selectors'
import './App.css';
import AppBarComponent from './components/app-bar'
import Menu from '@material-ui/icons/Menu'
import Add from '@material-ui/icons/Add'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { toggleDrawer, toggleNewPassView } from './reducers/ui-control'
import { getHistory } from './reducers/pass-list'
import DrawerModule from './modules/drawer/index'
import { withStyles } from '@material-ui/core/styles'
import muiTheme from './util/theme'

const styles = theme => ({
  root: {
    flexGrow: 1,
    zIndex: 1,
    maxHeight: '100%',
    overflow: 'hidden',
    width: '100%'
  },
  appFrame: {
    padding: theme.spacing.unit * 3
  },
  button: {
    margin: theme.spacing.unit
  },
  toolbar: theme.mixins.toolbar
});

const render = ({ toggleDrawer, toggleNewPassView, drawerIsOpen, title, classes, children }) => (
  <MuiThemeProvider theme={muiTheme}>
    <div className={classes.root}>
      <div className={classes.appFrame}>
        {title === PAGES.RESIDENT.title ?
          <AppBarComponent
            title={title ? title : ""}
            leftIcon={
              <Menu />
            }
            rightIcon={
              <Add />
            }
            onLeftButtonClick={toggleDrawer}
            onRightButtonClick={toggleNewPassView}
          />
          :

          <AppBarComponent
            title={title ? title : ""}
            leftIcon={
              <Menu />
            }
            onLeftButtonClick={toggleDrawer}

          />
        }
        <div className={classes.toolbar} />
        <DrawerModule />
        <div>
          {children}
        </div>
      </div>
    </div>
  </MuiThemeProvider>
);

class App extends Component {
  componentDidMount() {
    this.props.getHistory();
  }
  render() {
    const props = this.props;
    return render(props)
  }
}

App.propTypes = {
  drawerIsOpen: PropTypes.bool.isRequired,
  toggleDrawer: PropTypes.func.isRequired,
  toggleNewPassView: PropTypes.func.isRequired,
  getHistory: PropTypes.func.isRequired,
  title: PropTypes.string,
  classes: PropTypes.object.isRequired
}
const mapStateToProps = state => ({
  drawerIsOpen: drawerIsOpen(state),
  title: getPageTitle(state)
});

const mapDispatchToProps = dispatch => bindActionCreators({
  toggleDrawer,
  toggleNewPassView,
  getHistory
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(App));


// WEBPACK FOOTER //
// ./src/App.js